import React, { FC, memo, useMemo } from 'react';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import SimpleModal, { SimpleModalProps } from '../../../../components/SimpleModal';
import { KidDataResponse } from '../../services/KidService';

type Props = SimpleModalProps & {
  incompleteKids: KidDataResponse[];
  currentKidName: string;
};

const StyledSimpleModal = styled(SimpleModal)`
  button {
    margin-top: 20px;
  }
`;

const ConfirmResumeQuizModal: FC<Props> = ({ incompleteKids, currentKidName, onClose, ...modalProps }) => {
  const pendingKidNames = useMemo(() => {
    let kidNames = '';
    const kidsLength = incompleteKids.length;

    // get all incomplete children's names as a list
    if (kidsLength > 2) {
      kidNames = incompleteKids
        .filter(kid => kid.name !== currentKidName)
        .map(kid => kid.name)
        .reduce((prev, current, index) => {
          if (!prev) {
            return current;
          }
          const separator = index === kidsLength - 2 ? ' and ' : ', ';
          return `${prev}${separator}${current}`;
        }, '');
    }

    if (kidsLength === 2) {
      return incompleteKids.find(kid => kid.name !== currentKidName)?.name;
    }

    return kidNames;
  }, [incompleteKids, currentKidName]);

  return (
    <StyledSimpleModal closeable width="720px" onClose={onClose} {...modalProps}>
      Looks like you haven't finished the style quiz for {currentKidName}. We're on the question where you left off -
      please finish the quiz so we can send your 1st Drop!
      {pendingKidNames && (
        <>
          <br />
          <br />
          Don't forget to also finish the quiz for {pendingKidNames}.
        </>
      )}
      <Button onClick={onClose}>Ok</Button>
    </StyledSimpleModal>
  );
};

export default memo(ConfirmResumeQuizModal);
